import { VerifyBeneficiaryStatus } from 'api/v2/transactions/verifyBeneficiary';

export const VERIFICATION_FIELD_THEME: Record<
  VerifyBeneficiaryStatus,
  { controlClassName: string; isError?: boolean }
> = {
  [VerifyBeneficiaryStatus.Match]: {
    controlClassName: 'border-green-500',
  },
  [VerifyBeneficiaryStatus.CloseMatch]: {
    controlClassName: 'border-primary-600',
  },
  [VerifyBeneficiaryStatus.VerificationNotPossible]: {
    controlClassName: 'border-yellow-500',
  },
  [VerifyBeneficiaryStatus.NoMatch]: {
    controlClassName: 'border-red-500',
    isError: true,
  },
};
